import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './components/HomePage';
import ServicePage from './components/ServicePage';
import NewsListPage from './components/NewsListPage';
import NewsArticlePage from './components/NewsArticlePage';
import AdminGate from './components/admin/AdminGate';
import AdminLogin from './components/admin/AdminLogin';
import AdminNewsList from './components/admin/AdminNewsList';
import AdminNewsForm from './components/admin/AdminNewsForm';
import WhatsAppButton from './components/WhatsAppButton';
import { Toaster } from './components/ui/toaster';
import './App.css';

function App() {
  return (
    <div className="App bg-white">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/servicos/:slug" element={<ServicePage />} />
          <Route path="/news" element={<NewsListPage />} />
          <Route path="/news/:slug" element={<NewsArticlePage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <AdminGate>
                <AdminNewsList />
              </AdminGate>
            }
          />
          <Route
            path="/admin/news/new"
            element={
              <AdminGate>
                <AdminNewsForm />
              </AdminGate>
            }
          />
          <Route
            path="/admin/news/:id"
            element={
              <AdminGate>
                <AdminNewsForm />
              </AdminGate>
            }
          />
          <Route path="*" element={<HomePage />} />
        </Routes>
        <WhatsAppButton />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
